import React from "react"
import Avatar from "../images/avatar.png"
import NavBar from "./NavBar"
import AboutPage from "./About"
import ProjectsPage from "./Projects" 
import BlogsPage from "./Blogs"
import ContactPage from "./Contact"
import Footer from "./Footer"
import Resume from "../images/WalobwaCV.pdf"

import { AnimationOnScroll } from 'react-animation-on-scroll';


export default function HomePage(){

    return(
        <>
        <NavBar/>

        <section className="home-sec">
            <div className="side-line bg-purple-600"></div>
            <div className="details">
            <AnimationOnScroll initiallyVisible={true} duration={5} animateIn="animate__swing">
                <div
                    className="type text-purple-600">Walobwa Dan
                </div>
            </AnimationOnScroll>
                <p className="par text-2xl">Full-Stack Web Developer 😉!</p>
                
                <a target="_blank" href={Resume} rel="noreferrer">
                    <button type="submit" className="btn bg-purple-600 text-gray-100 px-2 mt-3">Download CV</button>
                </a>
                
                <div class="dropdown">
                    <button class="btn bg-purple-600 text-gray-100 px-2 mt-3 dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Contact Me
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <a class="dropdown-item" target="_blank" href="https://www.whatsapp.com/">
                            <i class="fa-brands fa-whatsapp text-green-700"></i> +254797716124</a>
                        </li>
                        <li>
                            <a class="dropdown-item" target="_blank" href="https://twitter.com/WalobwaDan">
                            <i className="fa-brands fa-twitter fa-github text-blue-700"></i>@WalobwaD</a>
                        </li>
                        <li>
                            <a class="dropdown-item" target="_blank" href="https://www.linkedin.com/in/dan-walobwa-a1bba0212/">
                            <i className="fa-brands fa-linkedin text-blue-700"></i> Dan Walobwa</a>
                        </li>
                        <li>
                            <a class="dropdown-item" target="_blank" href="https://www.linkedin.com/in/dan-walobwa-a1bba0212/">
                            <i className="fa-brands fa-google text-red-700"></i> walobwadan@gmail.com</a>
                        </li>
                    </ul>
                </div>

            </div>
            <div className="avatar">
                <img src={Avatar} alt="avatar"></img>
                
            </div>

        </section>

        <AboutPage/>
        <ProjectsPage/>
        <BlogsPage/>
        <ContactPage/>
        <Footer/>
        </>
    )
}